/**
 * Значения по умолчанию для PWA/браузера (совпадают с public/index.html, блок apple-mobile-web-app-title … theme-color).
 * Используются, пока в БД (JSON в поле meta) не заданы свои.
 */
export const PWA_META_DEFAULTS = {
  appleMobileWebAppTitle: 'UNIQOM',
  applicationName: 'UNIQOM',
  msapplicationTileColor: '#ffffff',
  themeColor: '#fefefe',
}

/** Если в БД нет request и у страницы нет defaults.meta — подставляется в meta keywords. */
export const SEO_KEYWORDS_DEFAULTS =
  'масла, антифризы, технические жидкости, моторные масла, антифризы для автомобилей, технические жидкости для автомобилей, японские масла, японские антифризы, японские технические жидкости, японская продукция'
/** Если в БД нет meta (и у страницы нет defaults.description) — подставляется в meta description. */
export const SEO_DESCRIPTION_DEFAULTS =
  'Продукция TCL: японская продукция для автомобилей - моторные масла, антифризы и технические жидкости для автомобилей.'

export const APP_DISPLAY_NAME = process.env.VUE_APP_NAME || 'TCL Japan'
